import React from 'react';
import EmojiPicker, {
  EmojiStyle,
  EmojiClickData,
  Emoji,
  Categories
} from "emoji-picker-react";
import { useState } from "react";
import IntlMessages from 'util/IntlMessages';

import {Button,IconButton,makeStyles, Tooltip } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import {isNull,isEmpty} from 'lodash'
import {updateAktivitetTag, deleteAktivitetTag,createTag,updateProjectTag,deleteProjectTag} from 'actions'
import {useDispatch, useSelector} from 'react-redux'
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import MoodIcon from '@mui/icons-material/Mood';
import { injectIntl } from 'react-intl';

const genStyle = (anchorEl) => {
  return makeStyles({
    menu: {
      '& .MuiMenu-paper': {
        width: 'max-content',
        paddingLeft: '0',
        paddingRight: '0',
        borderRadius: '9px',
        backgroundColor: 'transparent',
        boxShadow: Boolean(anchorEl) ? '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)' : 'none'
      },
      '& ul': {
        padding: '0 !important'
      }
    },
    w30px: {
      width: 30
    },
    cardSideOptionsButton: {
      textTransform: 'none'
    },
  })
}

function EmojiMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [error, setError] = React.useState(false)
  const [selectedEmoji, setSelectedEmoji] = useState("");

  
  const useStyles = genStyle(anchorEl)
  const classes = useStyles()

  function onClick(emojiData, event) {
    console.log(emojiData)
    setSelectedEmoji(emojiData.unified);
    props.addEmoji(emojiData.emoji)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // handleGoBack()
  };

  return (
    // <div className="App">
    //   {/* <h2>Emoji Picker React 4 Demo</h2>
    //   <div className="show-emoji">
    //     Your selected Emoji is:
    //     {selectedEmoji ? (
    //       <Emoji
    //         unified={selectedEmoji}
    //         emojiStyle={EmojiStyle.APPLE}
    //         size={22}
    //       />
    //     ) : null}
    //   </div> */}

    // </div>
    <div>
      <Tooltip title={<IntlMessages id="Title.Emojis"/>} aria-label='Emojis'>
        <IconButton size="small" color="primary" 
          onClick={handleClick}><MoodIcon/>
        </IconButton>
      </Tooltip>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
        variant={'menu'}
      >
        {
          Boolean(anchorEl) && 
          <EmojiPicker
            onEmojiClick={onClick}
            autoFocusSearch={false}
            searchPlaceholder={props.intl.formatMessage({ id: 'Search' })}
            lazyLoadEmojis={true}
            native
            emojiStyle={"google"}
            emojiVersion={"1.0"}
            categories={[
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Suggested' }),
              category: Categories.SUGGESTED
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Smiled' }),
              category: Categories.SMILEYS_PEOPLE
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Animals' }),
              category: Categories.ANIMALS_NATURE
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Foods' }),
              category: Categories.FOOD_DRINK
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Travels' }),
              category: Categories.TRAVEL_PLACES
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Activities' }),
              category: Categories.ACTIVITIES
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Objects' }),
              category: Categories.OBJECTS
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.Symbols' }),
              category: Categories.SYMBOLS
            },
            {
              name: props.intl.formatMessage({ id: 'Label.Emoji.FLAGS' }),
              category: Categories.FLAGS
            },
          ]}
          />
        }
       
      </Menu>
    </div>
  );
}

export default injectIntl(EmojiMenu);